import { Box, Button, Divider, ListItem, Typography } from '@mui/material'
import React, {useEffect, useState } from 'react'
import dentalImage from '../../../assets/DentalAppointment.png'
import {useNavigate} from 'react-router-dom'
import { useSelector } from 'react-redux'
import axiosInstance from '../../../api/axiosInstance'
import MapComponent from '../../../Components/Hostel/MapComponent'
import { useTranslation } from 'react-i18next'

function DentalMainPage() {
  const navigate = useNavigate()
  const [dentalData, setDentalData] = useState([])
  const [dentalContent, setDentalContent] = useState({})
  const {t} = useTranslation()
  const styles = useSelector((state) => state.styles)
  
  const language = useSelector((state) => state.language.language)
  const [data, setData] = useState([
    {
      id : 1,
      title : 'Private or shared transport options'
    },
    {
      id : 2,
      title : 'Meet & Greet service at the airport'
    },
    {
      id : 3,
      title : '24/7 availability for all flight times'
    }
  ])


  const getAboutUs = async () => {
    try {
        const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-dental-content`)
        setDentalContent(response?.data?.data[0])
    } catch (error) {
        console.log(error)
    }
}

console.log(dentalContent)

useEffect(() => {
    getAboutUs()
}, [])
  

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("/get-all-dentals")
      console.log(response)
      if(response?.status === 200){
        setDentalData(response?.data?.data)
      }
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
      fetchData()
  }, [])

  return (
    <>
    <Box sx={{display : 'flex', justifyContent : 'center'}}>
    <Box sx={{width :'90%', mt : '60px'}}>
        <Box>
            <Typography sx={{color : '#007eca', ...styles.h3}}>{dentalContent?.header?.[language]?.heading || '-'}</Typography>
        </Box>

        <Divider sx={{mt : 2, mb : 2}}/>

        <Box sx={{mt : 5}}>
            <Box
             sx={{
               width : '100%',
               height : '400px',
               backgroundImage : `url(${process.env.REACT_APP_FILE_PATH + dentalContent?.images?.header_image || dentalImage})`,
               backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              borderRadius : '24px',
              overflow: "hidden",
               }} />
        </Box>

        <Box sx={{mt : 5}}>
            <Typography sx={{color : '#434343', ...styles.h2}}>{dentalContent?.description?.[language]?.line1 || '-'}</Typography>

            <Box sx={{mt : '16px'}}>
                <Typography sx={{color : '#434343', ...styles.subheadingDescription }}>
                <span dangerouslySetInnerHTML={{ __html: dentalContent?.description?.[language]?.line2 }} />
                </Typography>
            </Box>
        </Box>

        <Box sx={{mt : '40px'}}>
            <Typography sx={{ color : '#434343', ...styles.h2}}>{dentalContent?.description?.[language]?.line3 || '-'}</Typography>

            <Box sx={{mt : '16px' }}>
            <Typography sx={{ color : '#434343', ...styles.subheadingDescription }}><span dangerouslySetInnerHTML={{ __html: dentalContent?.description?.[language]?.line4 }} /></Typography>
            </Box>
        </Box>
        
        <Divider sx={{mt : 2, mb : 2}}/>

        <MapComponent locations={dentalData} />

        <Divider sx={{mt : 2, mb : 2}} />

        <Box sx={{mt : 5, mb : 7}}>
            <Button
            onClick={() => navigate('/dental-clinics')}
             sx={{
               ...styles.button,
                borderRadius: "12px",
                ":hover": {
                  backgroundColor: "rgba(26, 36, 97, 1)",
                  color: "white",
                },
                backgroundColor: "rgba(26, 36, 97, 1)",
                color: "white",
                width : '200px'
              }}
            >{t("Book Appointment")}</Button>
        </Box>
    </Box>
    </Box>
    </>
  )
}

export default DentalMainPage